
const responsiveTables = document.querySelectorAll(".rte table:not(.default)");

responsiveTables.forEach(table => {
  //reset inline styles
  table.removeAttribute("style");
  table.removeAttribute("height");
  table.removeAttribute("width");
  table.querySelectorAll("td, tr, tbody").forEach(el => {
    el.removeAttribute("style");
  });

  const tableWrapper = document.createElement('div');
  tableWrapper.classList.add('table-wrapper');
  table.parentNode.insertBefore(tableWrapper, table);
  tableWrapper.appendChild(table);

  const tableNav =document.createElement('div');
  tableNav.classList.add('table-nav');
  tableWrapper.appendChild(tableNav);

  const arrowLeft = document.createElement('button');
  arrowLeft.classList.add("table-scroller-left");
  tableNav.appendChild(arrowLeft);

  const arrowRight = document.createElement('button');
  arrowRight.classList.add("table-scroller-right");
  tableNav.appendChild(arrowRight);
   
  const tableBody = table.querySelectorAll("tbody")[0];


  setTimeout(() => {
    const outerWidth = table.clientWidth;
    const innerWidth = table.querySelectorAll("tr")[0].clientWidth;
    if(innerWidth <= outerWidth){
      tableNav.classList.add("hidden");
    }
  }, 500);

  let interval;  

  arrowRight.addEventListener("click", (e) => moveRight(10));
  arrowLeft.addEventListener("click", (e) => moveLeft(10));

  arrowRight.addEventListener("keydown", function(e) {
    if (e.key === "Enter" || e.code === "Space") {
      moveRight();
    }
  });

  arrowLeft.addEventListener("keydown", function(e) {
    if (e.key === "Enter" || e.code === "Space") {
      moveLeft();
    }
  });

  arrowRight.addEventListener("mousedown", (e) => interval = setInterval(moveRight, 1));
  arrowLeft.addEventListener("mousedown", (e) => interval = setInterval(moveLeft, 1));
  arrowRight.addEventListener("touchstart", (e) => interval = setInterval(moveRight, 1));
  arrowLeft.addEventListener("touchstart", (e) => interval = setInterval(moveLeft, 1));

  arrowRight.addEventListener("mouseup", (e) => clearInterval(interval));
  arrowLeft.addEventListener("mouseup", (e) => clearInterval(interval));
  arrowRight.addEventListener("mouseleave", (e) => clearInterval(interval));
  arrowLeft.addEventListener("mouseleave", (e) => clearInterval(interval));
  arrowRight.addEventListener("touchend", (e) => clearInterval(interval));
  arrowLeft.addEventListener("touchend", (e) => clearInterval(interval));

  const moveRight = (amount = 1) => {
    tableBody.scrollLeft += amount;
  }

  const moveLeft = (amount = 1) => {
    tableBody.scrollLeft -= amount;
  }

  let pos = { top: 0, left: 0, x: 0, y: 0 };

  const mouseDownHandler = (e) => {
    console.log("test");
    pos = {
        // The current scroll
        left: tableBody.scrollLeft,
        top: tableBody.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
    };
    tableBody.style.cursor = 'grabbing';
    tableBody.style.userSelect = 'none';

    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
  };

  const mouseMoveHandler = (e) => {
    // How far the mouse has been moved
    const dx = e.clientX - pos.x;
    const dy = e.clientY - pos.y;

    // Scroll the element
    tableBody.scrollTop = pos.top - dy;
    tableBody.scrollLeft = pos.left - dx;
  };

  const mouseUpHandler = () => {
    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);

    tableBody.style.cursor = 'grab';
    tableBody.style.removeProperty('user-select');
  };


  tableBody.addEventListener("mousedown", (e) => mouseDownHandler(e));



});

